import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postReqwithoutHeader } from "../utils/ApiClient";
import debounce from "lodash.debounce";
import SpinnerComponent from "../components/SpinnerComponent";
import loginBanner from "../assets/splitpos-login-banner.webp";
import splitPosLogo from "../assets/splitPosLogo.png";
const ResetPassword = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userPassword, setUserPassword] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [formError, setFormError] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserPassword({ ...userPassword, [name]: value });
    const error = { ...formError };
    switch (name) {
      case "newPassword":
        error.newPassword =
          value.trim() === ""
            ? "Enter new password."
            : !value.match(
                  // eslint-disable-next-line
                  /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/,
                )
              ? "Atleast one number, alphabet and one special character are required."
              : "";
        break;
      case "confirmPassword":
        error.confirmPassword =
          value.trim() === ""
            ? "Confirm Password required."
            : value !== userPassword.newPassword
              ? "Confirm password not matched."
              : "";
        break;
      default:
        break;
    }
    setFormError({ ...error });
  };
  const validate = () => {
    let error = true;
    const submitError = { ...formError };
    if (userPassword.newPassword === "") {
      error = false;
      submitError.newPassword = "New Password Required.";
    } else if (userPassword.newPassword.length < 4) {
      error = false;
      submitError.newPassword = "New Password must be more than 4 characters.";
    }
    if (userPassword.confirmPassword === "") {
      error = false;
      submitError.confirmPassword = "Confirm Password is Required.";
    } else if (userPassword.confirmPassword !== userPassword.newPassword) {
      error = false;
      submitError.confirmPassword =
        "Password and confirm password not matched.";
    }
    setFormError({ ...submitError });
    return error;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const payloadData = {
        password: userPassword.newPassword,
        emailToken: search.substring(12),
      };
      try {
        setLoading(true);
        const response = await postReqwithoutHeader(
          "resetPassword",
          payloadData,
        );
        const { status, message } = response.data;
        if (status === 200) {
          setLoading(false);
          localStorage.clear();
          navigate("/sign-in");
          toast.success(message, {
            theme: "colored",
            autoClose: 950,
          });
        } else {
          toast.error(message, {
            theme: "colored",
            autoClose: 950,
          });
          setLoading(false);
        }
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          "Something went wrong. Please try again.";
        toast.error(message, { theme: "colored", autoClose: 950 });
        setLoading(false);
      }
    } else {
      toast.error("Something went wrong!", {
        theme: "colored",
        autoClose: 950,
      });
      setLoading(false);
    }
  };
  const delayCall = debounce(handleSubmit, 1500);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };
  return (
    <React.Fragment>
      <section className="login-page-v2">
        <div className="container-fluid">
          <div className="row min-vh-100">
            <div className="col-lg-7 d-none d-lg-flex login-brand-panel">
              <img
                src={loginBanner}
                alt="SplitPOS"
                className="login-banner-image"
              />
            </div>
            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <div className="login-card">
                <div className="text-center mb-4">
                  <div className="login-logo-wrapper">
                    <img
                      src={splitPosLogo}
                      alt="SplitPOS"
                      className="login-logo"
                    />
                  </div>
                  <div className="forgot-icon">
                    <i className="fa fa-key"></i>
                  </div>
                  <h2 className="mt-4">Reset Password</h2>
                  <p className="text-muted">
                    Choose a secure password to protect your account.
                  </p>
                </div>

                {/* New Password */}
                <div className="mb-3">
                  <label className="form-label">New Password</label>
                  <div className="input-group password-group">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      className="form-control"
                      placeholder="Enter new password"
                      name="newPassword"
                      value={userPassword?.newPassword}
                      onChange={handleChange}
                    />

                    <span
                      className="password-icon"
                      onClick={togglePasswordVisibility}
                    >
                      <i
                        className={`fa ${
                          isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                        }`}
                      />
                    </span>
                  </div>

                  <small className="text-danger">
                    {formError?.newPassword}
                  </small>
                </div>

                {/* Confirm Password */}
                <div className="mb-4">
                  <label className="form-label">Confirm Password</label>

                  <div className="input-group password-group">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      className="form-control"
                      placeholder="Confirm password"
                      name="confirmPassword"
                      value={userPassword?.confirmPassword}
                      onChange={handleChange}
                    />

                    <span
                      className="password-icon"
                      onClick={togglePasswordVisibility}
                    >
                      <i
                        className={`fa ${
                          isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                        }`}
                      />
                    </span>
                  </div>

                  <small className="text-danger">
                    {formError?.confirmPassword}
                  </small>
                </div>

                {loading ? (
                  <button className="login-btn" disabled>
                    <SpinnerComponent />
                    Please wait...
                  </button>
                ) : (
                  <button className="login-btn" onClick={delayCall}>
                    Reset Password
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="form-main login-page">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="form-body custom-width">
                <div className="form-body-main">
                  <div className="logo bg-transparent">
                    <img src={loginLogo} alt="loginLogo" />
                  </div>
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="New Password"
                      aria-required="true"
                      onChange={handleChange}
                      value={userPassword?.newPassword}
                      name="newPassword"
                      required
                    />
                    <p className="errorPara">{formError?.newPassword}</p>
                  </div>
                  <div className="form-group">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      name="confirmPassword"
                      id="confirmPassword"
                      className="form-control"
                      placeholder="Confirm Password"
                      aria-required="true"
                      onChange={handleChange}
                      value={userPassword?.confirmPassword}
                      required
                    />
                    <p className="errorPara">{formError?.confirmPassword}</p>
                    <span
                      className="formIcon"
                      onClick={togglePasswordVisibility}
                    >
                      <i
                        className={`fa ${isPasswordVisible ? "fa-eye" : "fa-eye-slash"}`}
                      />
                    </span>
                  </div>
                  <div className="form-group">
                    <button className="login-btn" onClick={delayCall}>
                      {loading ? <SpinnerComponent /> : "Reset Password"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </React.Fragment>
  );
};
export default ResetPassword;
